module.exports = __webpack_public_path__ + "img/7.6b9ff9b1.jpg";